export default function downloadFile(resp) {
  const data = resp.data

  const header = resp.headers['content-disposition'];
  let regx = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
  let result = regx.exec(header);
  let filename = decodeURI(result[1]);

  var reader = new FileReader();
  reader.readAsDataURL(data);
  reader.onload = function (e) {
    var a = document.createElement('a');
    a.download = filename;
    a.href = e.target.result;
    document.getElementsByTagName('body')[0].appendChild(a);
    a.click();
  }
}
